/** @format */

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	homefieldIconAlertErrorFilled,
	HomefieldIconLibraryModule,
	homefieldIconLocationNearme,
	homefieldIconLocationPinFilled,
	homefieldIconMobilePhone,
	homefieldIconNavigationArrowForward,
	homefieldIconSearch,
	homefieldIconSignCircledCheck,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';

import { AccordionModule } from '../accordion/accordion.module';
import { AlertMessageModule } from '../alert-message/alert-message.module';
import { UrlSanitizerPipe } from '@shared/utils/pipes';
import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { SideNavModule } from '../side-nav/side-nav.module';
import { StoreLayerComponent } from './store-layer.component';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@NgModule({
	declarations: [StoreLayerComponent],
	imports: [
		AccordionModule,
		AlertMessageModule,
		CommonModule,
		FormsModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule,
		NgOptimizedImage,
		ProgressSpinnerModule,
		ReactiveFormsModule,
		SideNavModule,
		UrlSanitizerPipe
	],
	exports: [StoreLayerComponent]
})
export class StoreLayerModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconSearch,
			homefieldIconNavigationArrowForward,
			homefieldIconLocationNearme,
			homefieldIconLocationPinFilled,
			homefieldIconMobilePhone,
			homefieldIconSignCircledCheck,
			homefieldIconAlertErrorFilled
		]);
	}
}
